import axios from 'axios'
import axiosRetry from 'axios-retry'
import Log from './Log'

let instance = null
const typePresets = {
  json: {
    headers: {
      'Content-Type': 'application/json'
    },
    transformRequest: data => JSON.stringify(data)
  },
  none: {}
}

export default class Network {
  constructor (options = {}) {
    this.axios = axios.create(options)
    axiosRetry(this.axios, {
      retries: 1000000000,
      retryDelay: () => {
        window.noci.chatbot.status.network = false
        return 1000
      }
    })
  }

  static getInstance () {
    if (instance === null) {
      instance = new Network()
    }
    return instance
  }

  async get (url, data = {}, type = 'none', overwriteOptions = {}) {
    try {
      const ret = await this.axios.get(url, {
        ...typePresets[type],
        ...overwriteOptions,
        params: data
      })

      if (ret) {
        window.noci.chatbot.status.network = true
        return ret.data
      }
    } catch (err) {
      Log.error(err)
    }
    return null
  }

  async delete (url, data = {}, type = 'none', overwriteOptions = {}) {
    try {
      const ret = await this.axios.delete(url, {
        ...typePresets[type],
        ...overwriteOptions,
        params: data
      })

      if (ret) {
        window.noci.chatbot.status.network = true
        return ret.data
      }
    } catch (err) {
      Log.error(err)
    }
    return null
  }

  async post (url, data = {}, type = 'none', overwriteOptions = {}) {
    try {
      const ret = await this.axios.post(url, data, {
        ...typePresets[type],
        ...overwriteOptions
      })

      if (ret) {
        window.noci.chatbot.status.network = true
        return ret.data
      }
    } catch (err) {
      Log.error(err)
    }
    return null
  }

  async put (url, data = {}, type = 'none', overwriteOptions = {}) {
    try {
      const ret = await this.axios.put(url, data, {
        ...typePresets[type],
        ...overwriteOptions
      })

      if (ret) {
        window.noci.chatbot.status.network = true
        return ret.data
      }
    } catch (err) {
      Log.error(err)
    }
    return null
  }

  async patch (url, data = {}, type = 'none', overwriteOptions = {}) {
    try {
      const ret = await this.axios.patch(url, data, {
        ...typePresets[type],
        ...overwriteOptions
      })

      if (ret) {
        window.noci.chatbot.status.network = true
        return ret.data
      }
    } catch (err) {
      Log.error(err)
    }
    return null
  }
}
